import { useState, useContext, useCallback } from "react";
import ShopContext from "context/ShopContext";
import StaffAccessCodeDialog from "components/popups/StaffAccessCodeDialog/StaffAccessCodeDialog";

export const usePermission = () => {
  const { selectedShop } = useContext(ShopContext);
  const [authDialog, setAuthDialog] = useState({
    isOpen: false,
    actionKey: null,
    onSuccess: null,
    title: "Access Required",
  });

  const checkPermissionAndExecute = useCallback(
    (actionKey, onSuccess, fallbackTitle = "Access Required") => {
      const requiredCode = selectedShop?.config?.staff_access_codes?.[actionKey];

      if (requiredCode) {
        setAuthDialog({
          isOpen: true,
          actionKey,
          onSuccess,
          title: fallbackTitle,
        });
      } else {
        if (onSuccess) onSuccess();
      }
    },
    [selectedShop]
  );

  const handleClose = useCallback(() => {
    setAuthDialog((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const handleSuccess = useCallback(() => {
    const successCallback = authDialog.onSuccess;
    setAuthDialog((prev) => ({ ...prev, isOpen: false }));
    if (successCallback) successCallback();
  }, [authDialog.onSuccess]);

  const PermissionDialog = useCallback(
    () => (
      <StaffAccessCodeDialog
        open={authDialog.isOpen}
        onClose={handleClose}
        onSuccess={handleSuccess}
        requiredCode={selectedShop?.config?.staff_access_codes?.[authDialog.actionKey]}
        title={authDialog.title}
      />
    ),
    [authDialog, handleClose, handleSuccess, selectedShop]
  );

  return { checkPermissionAndExecute, PermissionDialog, isPermissionDialogOpen: authDialog.isOpen };
};
